let soundManager;

class SimpleSoundManager {
  constructor() {
    this.sounds = {};
    this.soundsReady = false;
  }
  
  init() {
    this.sounds = {
      cart: document.getElementById('cart-sound'),
      menu: document.getElementById('menu-sound')
    };
    
    this.setupEvents();
    this.enableSoundsOnInteraction();
  }
  
  enableSoundsOnInteraction() {
    const activate = () => {
      if (this.soundsReady) return;
      
      // Alle Sounds einmal stumm abspielen um sie zu aktivieren
      Object.values(this.sounds).forEach(audio => {
        if (audio) {
          audio.volume = 0;
          audio.play().then(() => audio.pause()).catch(() => {});
        }
      });
      
      this.soundsReady = true;
      console.log('Sounds aktiviert');
    };
    
    // Bei JEDER Art von Interaction aktivieren
    ['click', 'touchstart', 'keydown', 'mousemove'].forEach(event => {
      document.addEventListener(event, activate, { once: true, passive: true });
    });
  }
  
  play(name) {
    const audio = this.sounds[name];
    if (!audio || !this.soundsReady) return;
    
    audio.volume = 0.5;
    audio.currentTime = 0;
    audio.play()
      .then(() => console.log(`${name} gespielt`))
      .catch(() => console.log(`${name} blockiert`));
  }
  
  setupEvents() {
    // Cart
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', () => {
        setTimeout(() => this.play('cart'), 300);
      });
    });
    
    // Menu - mit kurzer Verzögerung
    document.querySelectorAll('.header__icon--menu, summary.header__menu-toggle, [data-disclosure-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        // Kleine Verzögerung damit Sounds sicher aktiviert sind
        setTimeout(() => this.play('menu'), 50);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  soundManager = new SimpleSoundManager();
  soundManager.init();
});